import {Component} from '@angular/core';
import {Event, NavigationEnd, Router, RouterModule} from '@angular/router';
import {filter} from 'rxjs/operators';
import {FaIconLibrary} from '@fortawesome/angular-fontawesome';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {far} from '@fortawesome/free-regular-svg-icons';
import {fab} from '@fortawesome/free-brands-svg-icons';

/* v8 ignore next */
declare let gtag: (type: string, key: string, options: any) => void;

@Component({
    selector: 'app-root',
    template: ` <router-outlet></router-outlet>`,
    styles: [],
    imports: [RouterModule],
})
export class AppComponent {
    // build comment
    constructor(
        private router: Router,
        iconLibrary: FaIconLibrary,
    ) {
        iconLibrary.addIconPacks(fas, far, fab);

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd && (window as any).ga_ei_key))
            .subscribe((event: Event) => {
                gtag('config', (window as any).ga_ei_key, {
                    page_path: (event as NavigationEnd).urlAfterRedirects,
                });
            });
    }
}
